import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/homeData";

const footerLinks = [
  {
    title: "快速导航",
    links: [
      { label: "首页", href: "/" },
      { label: "热门推荐", href: "/#hot" },
      { label: "分类浏览", href: "/#categories" },
      { label: "最新资讯", href: "/#news" },
    ],
  },
  {
    title: "漫画分类",
    links: [
      { label: "热血格斗", href: "/category/rexue" },
      { label: "恋爱甜宠", href: "/category/lianai" },
      { label: "悬疑推理", href: "/category/xuanyi" },
      { label: "仙侠玄幻", href: "/category/xianxia" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", href: "/about" },
      { label: "用户口碑", href: "/about#testimonials" },
      { label: "联系方式", href: "/about#contact" },
      { label: "常见问题", href: "/#faq" },
    ],
  },
];

const socialLinks = [
  { label: "微博", icon: "ri-weibo-line", href: siteInfo.social.weibo },
  { label: "微信", icon: "ri-wechat-line", href: "#" },
  { label: "B站", icon: "ri-bilibili-line", href: siteInfo.social.bilibili },
  { label: "抖音", icon: "ri-tiktok-line", href: siteInfo.social.douyin },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14 md:py-20 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-black text-background-50">
                51<span className="text-accent-500">漫画</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed max-w-sm text-foreground-300">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target={social.href !== "#" ? "_blank" : undefined}
                  rel={social.href !== "#" ? "nofollow noopener noreferrer" : undefined}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50/70 hover:bg-accent-500 hover:text-background-50 transition-all duration-200"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} w-4 h-4 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-foreground-400">
            <a href="#" className="hover:text-accent-400 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors duration-200">用户协议</a>
            <a href="#" className="hover:text-accent-400 transition-colors duration-200">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}